import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SubscriptionContainer } from 'app/modules/common/helpers/SubscriptionsContainer';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SendingService } from 'app/modules/fuse/services/sending.service';

@Component({
    selector: 'app-discharges-popup',
    templateUrl: './discharges-popup.component.html',
    styleUrls: ['./discharges-popup.component.scss'],
    standalone: false
})
export class DischargesPopupComponent implements OnInit {
    @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
    DateFilterType = DateFilterTypes;

    private subs: SubscriptionContainer;
    public allDoctors = [];
    public admintrativeUsers = [];
    public hideElMedicoInput = false;
    public SelectedDoctor;    
    public SelectedAdministrativeUser: any;
    public dischargeForm: UntypedFormGroup;
    public IsCancelDissabled:boolean=false;

    constructor(
        private _dialogRef: MatDialogRef<DischargesPopupComponent>,
        private _sharedService: SharedService,
        private _sendingService: SendingService,
        public _fb: UntypedFormBuilder,
         @Inject(MAT_DIALOG_DATA) private users
        ) {         
            this.allDoctors = users.medicos
            this.admintrativeUsers = users.admintrativeUsers
            this._medicoList=this.allDoctors;
        }

    ngOnInit(): void {
        this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');
        this.createDischargeForm();     
        this.hideElMedicoInput = false;
    }
    SearchDoctors()
    {
      const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';
  
      this._medicoList =this.allDoctors.filter(m=>{
        if(m.nombre!=null)
        {
            const viewValue : string=m.nombre.toLowerCase();
            return viewValue.indexOf(searchInput) > -1;
        }
      }) 
    }
    createDischargeForm() {
        this.dischargeForm = this._fb.group({
            Enviar: ["all"],
            SelectedDoctor: [''],
            SelectedAdministrativeUser: [''],
            DateFrom: ['', Validators.required],
            DateTo: ['', Validators.required],
            SelectedCompanyId: [this._sendingService.selectedCompanyId]
        });
    }

    public close(): void {
        this._dialogRef.close();
    }

    public getFormControl(formControlName: string): UntypedFormControl {
        return this.dischargeForm.get(formControlName) as UntypedFormControl;
    }

    public onDoctorChange(event: any) {
        this.SelectedDoctor = event.value;
    }

    public onAdminUserChange(event: any) {
        this.SelectedAdministrativeUser = event.value;
        //this._medicoList=this.admintrativeUsers;
        setTimeout(() => {
          this.doctorSearchInput.nativeElement.value=null;
        }, 1000);
    }

    public enviarChangeHandler(e): void {
        if ("single" === e.target.value) {
            this.hideElMedicoInput = true;
            this.dischargeForm.get('SelectedDoctor').setValidators([Validators.required]);
            this.dischargeForm.get('SelectedDoctor').untouched;
            this.dischargeForm.updateValueAndValidity();
        } else {
            this.hideElMedicoInput = false;
            this.dischargeForm.get('SelectedDoctor').clearValidators();
            this.dischargeForm.get('SelectedDoctor').reset();
            this.dischargeForm.get('SelectedDoctor').untouched;
            this.dischargeForm.get('SelectedDoctor').valid;
            this.dischargeForm.updateValueAndValidity();
        }
    }

    public setFilterValues(filterType: string, data: Date = null): void {
        switch (filterType) {
            case 'commonDateFrom':
                this.dischargeForm.patchValue({ DateFrom: DateHelper.getUTCDateString(data) });
                break;
            case 'commonDateTo':
                this.dischargeForm.patchValue({ DateTo: DateHelper.getUTCDateString(data) });
                break;
            default:
                break;
        }
    }

    onSubmit(): void {
        this.dischargeForm.markAllAsTouched();
        if (this.dischargeForm.valid) {
            this.IsCancelDissabled=true;
            console.log(this.dischargeForm.value);
            this._sendingService.Altas(this.dischargeForm.value).subscribe(res => {
                if (res.code === 0) {
                    console.log(res);
                    this.close();
                    this.IsCancelDissabled=false;
                    this._sharedService.ShowSnackBar(res.result);
                } else {
                    this.close();
                    this.IsCancelDissabled=false;
                    this._sharedService.ShowSnackBar('Notificación Falló');
                }
            }, error => {
                this.close();
                this.IsCancelDissabled=false;
                this._sharedService.ShowSnackBar('API Se produjo un error');
                console.error(error);
            });

           
        }
    }

}
